"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderReactRoot = void 0;
const tslib_1 = require("tslib");
const ReactDOMClient = tslib_1.__importStar(require("react-dom/client"));
const renderWeakMap = new WeakMap();
const renderReactRoot = (el, container) => {
    // Keeping a reference to previous roots causes an error.
    // Already (correctly) unmouted elements are not unmounted again, and triggers an error.
    //
    // let root = renderWeakMap.get(container);
    // if (!root) {
    //   renderWeakMap.set(container, (root = ReactDOMClient.createRoot(container)));
    // }
    const root = ReactDOMClient.createRoot(container);
    root.render(el);
    return () => {
        // requestAnimationFrame(() => {
        //   // This pervents this warning:
        //   // Warning: Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.
        //   // https:stackoverflow.com/questions/73459382/react-18-async-way-to-unmount-root
        // });
        // This needs to be syncronous, if not, in a raf it may be to late, the element may be gone.
        // To reproduce, move this in RAF and play with filters.
        root.unmount();
    };
};
exports.renderReactRoot = renderReactRoot;
